import { Injectable } from '@angular/core';
import { SequenceOutput, SequencesService } from 'core/http/project/sequences/sequences.service';
import { Observable } from 'rxjs';

@Injectable()
export class SequencesResolver {
  constructor(private sequencesService: SequencesService) {
  }

  resolve(): Observable<SequenceOutput[]> {
    return this.sequencesService.getAllSequences();
  }
}
